import {ICounterparties, ICounterpartiesListItem, CounterpartiesResponseType} from "@/entity/finance/counterparties/counterparties.types";

export default class Counterparties implements ICounterparties {
    total: number;
    data: ICounterpartiesListItem[] = [];
    constructor(data: CounterpartiesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}